import React from 'react'
import { Field } from 'formik'
import { Pinterest } from 'react-bootstrap-icons'

export default function PinterestButton({ active, onClick, variant = 'button', name = 'platforms', value = 'pinterest' }) {
  const baseClasses = 'inline-flex h-9 w-9 items-center justify-center rounded-lg text-red-700 dark:text-red-500 transition-colors'
  const activeClasses = 'bg-rb-light-green dark:bg-rb-green/10 border-2 border-rb-green'
  const inactiveClasses = 'bg-white dark:bg-rb-dark-mode border-1 border-border-primary dark:border-rb-dark-mode-lighter hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter'
  const buttonClasses = `${baseClasses} ${active ? activeClasses : inactiveClasses}`

  if (variant === 'checkbox') {

    return (
      <label className={buttonClasses}>
        <Field type="checkbox" name={name} value={value} className="hidden" />
        <Pinterest />
      </label>
    )
  }

  return (
    <button className={buttonClasses} onClick={onClick}>
      <Pinterest />
    </button>
  )
}
